export const edinet = {
    financials: {
        consolidated: {
            bs: [
                'jpcrp_cor:ConsolidatedBalanceSheetTextBlock',
                'jpcrp_cor:QuarterlyConsolidatedBalanceSheetTextBlock',
                'jpigp_cor:ConsolidatedStatementOfFinancialPositionIFRSTextBlock'
            ],
            in: [
                'jpcrp_cor:ConsolidatedStatementOfIncomeTextBlock',
                'jpcrp_cor:YearToQuarterEndConsolidatedStatementOfIncomeTextBlock',
                'jpigp_cor:ConsolidatedStatementOfProfitOrLossIFRSTextBlock'
            ],
            cf: [
                'jpcrp_cor:ConsolidatedStatementOfCashFlowsTextBlock',
                'jpcrp_cor:QuarterlyConsolidatedStatementOfCashFlowsTextBlock',
                'jpigp_cor:ConsolidatedStatementOfCashFlowsIFRSTextBlock'
            ]
        },
        nonconsolidated: {
            bs: [
                'jpcrp_cor:BalanceSheetTextBlock',
                'jpcrp_cor:QuarterlyBalanceSheetTextBlock',
            ],
            in: [
                'jpcrp_cor:StatementOfIncomeTextBlock',
                'jpcrp_cor:YearToQuarterEndStatementOfIncomeTextBlock',
            ],
            cf: [
                'jpcrp_cor:StatementOfCashFlowsTextBlock',
                'jpcrp_cor:YearToQuarterEndStatementOfCashFlowsTextBlock',
                'jpcrp_cor:QuarterlyStatementOfCashFlowsTextBlock'
            ]
        }
    }
}

export const edgar = {
    financials: {
        bs: ['us-gaap:Assets'],
        in: ['us-gaap:ProfitLoss', 'us-gaap:NetIncomeLoss'],
        cf: ['us-gaap:NetCashProvidedByUsedInOperatingActivities'],
        ci: ['us-gaap:ComprehensiveIncomeNetOfTaxIncludingPortionAttributableToNoncontrollingInterest']
    }
}